/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

$(document).ready(function() {

    var menu = $('#location-list-dropdown');
    var btn = $('#my-store-btn');

    btn.click(function(event) {
        event.preventDefault();
        event.stopPropagation();
        if (menu.is(":visible")) {
            menu.slideUp(400);
        } else {
            menu.slideDown(400);
        }
    });

    $(document).click(function(event) {
        if (menu.is(":visible") && !$(event.target).is(menu) && !$(event.target).is(btn)) {
            menu.slideUp(400);
        }
    });

    // Click to set img 
    $('.thumbnail--gallery-img').click(function() {
        var img = $(this).find('img').attr('src');
        $('.thumbnail--gallery-img').removeClass('active');
        $(this).addClass('active');
        $('.location__main-gallery-img img').attr('src', img);
    });

    // Slick Slider
   var options = {
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      fade: true,
      asNavFor: '.gallry-thumbanil-img-slider'
    }
    var options1 = {
      slidesToShow: 5,
      slidesToScroll: 1,
      asNavFor: '.gallry-top-img-slider',
      arrows: true,
      focusOnSelect: true,
      nextArrow: `<button class="slide-arrow prev-arrow"><svg width="800px" height="800px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M10 7L15 12L10 17" stroke="#000000" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg></button>`,
      prevArrow: `<button class="slide-arrow next-arrow"><svg width="800px" height="800px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M10 7L15 12L10 17" stroke="#000000" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg></button>`,
    }

    $('.thumbnail--gallery-img.thumbnail--last').click(function() {
        $('.gallery-img-popup--wrapper').css('display', 'flex');
      
        $('.gallry-top-img-slider').slick(options);
        $('.gallry-top-img-slider').slick('setPosition');
        $(".gallry-top-img-slider").on("init", function(event) {});

        $('.gallry-thumbanil-img-slider').slick(options1);
        $('.gallry-thumbanil-img-slider').slick('setPosition');
        $(".gallry-thumbanil-img-slider").on("init", function(event) {});
    });
    $('.popup-close').click(function() {
        $('.gallery-img-popup--wrapper').hide();
    });

    // New Arrival Product
    $('.block__new-product-slider').slick({
      infinite: false,
      slidesToShow: 4,
      slidesToScroll: 4,
      prevArrow: $('.block__prev--arrow'),
      nextArrow: $('.block__next--arrow'),
      responsive: [
        {
          breakpoint: 1600,
          settings: {
            slidesToShow: 4,
            slidesToScroll: 4,
          }
        },
        {
          breakpoint: 1360,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3
          }
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2
          }
        },
        {
          breakpoint: 550,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
        // You can unslick at a given breakpoint now by adding:
        // settings: "unslick"
        // instead of a settings object
      ]
    });

    $(document).on('click', '.block__new-product-variant--wrapper li', function(e) {
      var dataVal = $(this).attr('data-variant-id');
      var dataQty = $(this).attr('data-variant-qty');
      $('.block__new-product-variant--wrapper li').removeClass('active');
      $(this).parents('.block__new-product-box').find('.block__add-to-cart-btn').removeClass("available sold-out");
      $(this).addClass('active');
      $(this).parents('.block__new-product-box').find('form [name="id"]').val(dataVal)
      if (dataQty == 0) {
        $(this).parents('.block__new-product-box').find('.block__add-to-cart-btn').addClass("sold-out");
      } else if (dataQty > 0) {
        $(this).parents('.block__new-product-box').find('.block__add-to-cart-btn').addClass("available");
      }
    });

    $(document).on('click', '.block__add-to-cart-btn', function(e) {
      var varID = $(this).parents('form').find('[name="id"]').val();
      let formData = {
       'items': [{
        'id': varID,
        'quantity': 1
        }]
      };
      
      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
      })
      .then(response => {
        setTimeout(function() {
          document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
            bubbles: true
          }));  
          var cartDrawerButtonSelector = "Header__Icon Icon-Wrapper Icon-Wrapper--clickable ";
          var cartDrawerButton = document.getElementsByClassName(cartDrawerButtonSelector)[3];
          cartDrawerButton.click();
        }, 1000)
        return response.json();
      })
      .catch((error) => {
        console.error('Error:', error);
      });
  });

  // Footer Accordian
    if ($(window).width() < 768) {
        $('.footer-menu-box h3').click(function() {
            if ($(this).hasClass("active")) {
                $(this).removeClass("active").parents('.footer-menu-box').find('ul').slideUp();
            } else {
                $(".footer-menu-box h3.active").next().slideUp();
                $(".footer-menu-box h3.active").removeClass("active");
                $(this).addClass("active").parents('.footer-menu-box').find('ul').slideDown();
            }
            return false;
        });
    }

    // Variant Slider
    $('.block__variant-slider').slick({
      infinite: false,
      slidesToShow: 5,
      slidesToScroll: 1,
      arrows: true,
      prevArrow:'<div class="slick-prev pull-left"><svg width="7" height="12" viewBox="0 0 7 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6 1L1 6L6 11" stroke="#6C7079"></path></svg></div>',
      nextArrow:'<div class="slick-next pull-right"><svg width="7" height="12" viewBox="0 0 7 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 1L6 6L1 11" stroke="#6C7079"></path></svg></div>',
      responsive: [
        {
          breakpoint: 375,
          settings: {
            slidesToShow: 4
          }
        },
        {
          breakpoint: 550,
          settings: {
            slidesToShow: 5
          }
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 4
          }
        },
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 3
          }
        },
        {
          breakpoint: 1360,
          settings: {
            slidesToShow: 4
          }
        }
      ]
    });


    mobileOnlySlider(".block__shop-bran--box-wrapper", true, 767);
    function mobileOnlySlider($slidername, $arrows, $breakpoint) {
      var slider = $($slidername);
      var settings = {
          mobileFirst: true,
          slidesToShow: 2,
          arrows: $arrows,
          prevArrow: $('.block__brand-prev--arrow'),
          nextArrow: $('.block__brand-next--arrow'),
          responsive: [
            {
              breakpoint: 479,
              settings: {
                slidesToShow: 2
              }
            },
            {
              breakpoint: 480,
              settings: {
                slidesToShow: 3
              }
            },
            {
              breakpoint: $breakpoint,
              settings: "unslick"
            }
          ]
      };
      slider.slick(settings);
      $(window).on("resize", function () {
        if ($(window).width() > $breakpoint) {
          return;
        }
        if (!slider.hasClass("slick-initialized")) {
          return slider.slick(settings);
        }
      });
    } // Mobile Only Slider

    const featureCategorys = document.querySelectorAll('.block__feature-category-box-right')
    $('.slick-before-init').removeClass('slick-before-init')
    featureCategorys.forEach(category => {
      $(category).slick({
        infinite: false,
        slidesToShow: 3,
        slidesToScroll: 1,
        prevArrow: $(category).closest('.block__feature-category-box').find('.block_new-product-slider-navigation .block__feature-product-prev--arrow'),
        nextArrow: $(category).closest('.block__feature-category-box').find('.block_new-product-slider-navigation .block__feature-product-next--arrow'),
        responsive: [
          {
            breakpoint: 1600,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 1,
            }
          },
          {
            breakpoint: 1360,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 1
            }
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1
            }
          },
          {
            breakpoint: 550,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1
            }
          }
        ]
      });
    });
})